import React, { useEffect, useState } from 'react'
import DataTable from '../common/DataTable/DataTable'
import './Chapter.css';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { usePermission } from '../../hooks/usePermissions';

const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
);

const TrashIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4h6v2" />
    </svg>
);

const ChapterMaster = () => {

    const navigate = useNavigate();
    const [chapters, setChapters] = useState([]);
    const {hasPermission} = usePermission()

    const handleDelete = (id) => {
        if (!window.confirm("Are you sure you want to delete this chapter?")) return;

        api.delete(`/chaptermaster/${id}`)
            .then(() => {
                setChapters(prev => prev.filter(chapter => chapter.chapterid !== id));
            })
            .catch((error) => {
                const msg = error?.message || "Cannot delete: This chapter is linked to learning modules.";
                toast.error(msg);
            });
    };

    const chapterColumns = [
        { key: "chapterid", label: "ID" },
        { key: "chapter_name", label: "Chapter Name" },
        { key: "chapter_brief", label: "Chapter Brief" },
        {
            key: "actions",
            label: "Actions",
            render: (value, row) => (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                   {hasPermission("MODIFY_CHAPTERMASTER") && (
                        <button
                            className="cm-icon-btn"
                            title="Edit"
                            onClick={() => navigate(`/chaptermaster/add/${row.chapterid}`)}
                        >
                            <EditIcon />
                        </button>
                    )}
                   {hasPermission("DELETE_CHAPTERMASTER") && (
                        <button
                            className="cm-icon-btn delete"
                            title="Delete"
                            onClick={() => handleDelete(row.chapterid)}
                        >
                            <TrashIcon />
                        </button>
                    )}
                </div>
            ),
        },
    ];

    useEffect(() => {
        api.get('/chaptermaster')
            .then((response) => {
                setChapters(response.data);
            })
            .catch((error) => {
                console.error('Error fetching chapter data:', error);
            });
    }, []);

    return (
        <div className="cm-pageContainer">
            <ToastContainer position="top-center" autoClose={2000} />
            
            <div className="cm-header">
                <div className="cm-headerLeft">
                    <h1>Chapter Master</h1>
                    <p>Manage learning chapters and details</p>
                </div>

                <div className="cm-headerActions">
                    {hasPermission("CREATE_CHAPTERMASTER") && (
                        <button className="cm-btnAdd" onClick={() => navigate("/chaptermaster/add")}>
                            + Add Chapter
                        </button>
                    )}
                </div>
            </div>

            <DataTable columns={chapterColumns} data={chapters} />
        </div>
    )
}

export default ChapterMaster